import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { HuonekorttiResponse } from '@/api/models/huonekortti-response';
import { onUnmounted, PropType } from 'vue';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';
import ComHuonekorttiMuokkausTable from './ComHuonekorttiMuokkausTable.vue';
import ComHuonekorttiMuokkausHuonekortti from './ComHuonekorttiMuokkausHuonekortti.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiMuokkaus',
  props: {
    huonekortit: {
        type: Object as PropType<HuonekorttiResponse[]>,
        required: true,
    }
},
  setup(__props) {

const props = __props
const { huonekortit: _huonekortit, resetState } = useHuonekorttiMuokkausComponent()

_huonekortit.value = structuredClone(props.huonekortit)

onUnmounted(() => {
    resetState()
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ComHuonekorttiMuokkausHuonekortti),
    _createVNode(_component_el_divider, { "border-style": "none" }),
    _createVNode(ComHuonekorttiMuokkausTable)
  ], 64))
}
}

})